import { render } from "./DashboardDriver.vue?vue&type=template&id=405bd6fe&ts=true"
import script from "./DashboardDriver.vue?vue&type=script&lang=ts"
export * from "./DashboardDriver.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__